import 'ng-infinite-scroll';
import 'angular-inview';
import { NgModule } from 'ng-metadata/core';
import {PrmSearchResultAvailabilityLine} from './searchResultAvailability/searchResultAvailabilityLine.directive';
// import {PrmSearchResultThumbnailContainer} from './searchResultThumbnail/searchResultThumbnailContainer.directive';
import {PrmSearchResultFrbrLine} from './searchResultFrbr/searchResultFrbrLine.directive';
import {BriefResultService} from '../briefResult/briefResult.service';
import {PrmBriefResult} from '../briefResult/briefResult.directive';
import {SnippetService} from '../snippet/snippet.service';
import {PrmSnippet} from '../snippet/snippet.directive';
import {ActionsModule} from '../actions/actions.module';
import {CitationTrailsService} from '../citationTrails/citationTrails.service';
import {UpFrontActionsService} from '../briefResult/upFrontActions.service';
import {PrmBriefResultContainer} from '../briefResult/briefResultContainer.directive';
import {PrmNoSearchResult} from './searchResultList/noSearchResult.directive';
import {PrmSavedQueryFilter} from './savedQueriesList/savedQueryFilter/savedQueryFilter.directive';
import {PrmSavedQueriesList} from './savedQueriesList/savedQueriesList.directive';
import {PrmPageNavMenu} from './searchResultList/pageNavMenu/pageNavMenu.directive';
import {PageNavMenuService} from './searchResultList/pageNavMenu/pageNavMenu.service';
import {PrmSearchResultList} from './searchResultList/searchResult.directive';
import {SearchResultSortBy} from './searchResultSortBy/searchResultSortBy.directive';
import {TimesCitedService} from "../timesCited/timesCited.service";
import {PrmTimesCited} from "../timesCited/timesCited.directive";
import {PrmFeaturedResults} from "./featuredResults/featuredResults.directive";
import {PrmFeaturedResultItem} from "./featuredResults/featuredResultItem.directive";
import {PrmSearchErrorMessage} from "./errorMessage/searchErrorMessage.directive";
import {PrmSearchExplain} from "./explain/searchExplain.directive";
import {SearchErrorMessageService} from "./errorMessage/searchErrorMessage.service";
import {PrmQuickLink} from "../quickLink/quickLink.directive";

import {PrmSearchResultJournalIndicationLine} from './searchResultJournalIndication/searchResultJournalIndicationLine.directive';
import {SearchResultThumbnailContainerService} from "./searchResultThumbnail/searchResultThumbnailContainer.service";
import {PrmChaptersResultsLine} from "./searchResultsChaptersAndReviews/chaptersResultsLine.directive";
import {ChaptersResultsLineService} from "./searchResultsChaptersAndReviews/chaptersResultsLine.service";
import {PrmSearchResultToolBar} from "./searchResultToolBar/searchResultToolBar.directive";
import {SearchResultAddToFavoritesMenuService} from "./searchResultAddToFavoritesMenu/searchResultAddToFavoritesMenu.service";
import {PrmSearchResultAddToFavoritesMenu} from "./searchResultAddToFavoritesMenu/searchResultAddToFavoritesMenu.directive";
import {FavoritesEditLabelsMenuService} from '../../favorites/favoritesEditLabelsMenu/favoritesEditLabelsMenu.service';

@NgModule({
    declarations: [PrmBriefResult,
        PrmBriefResultContainer,
        PrmNoSearchResult,
        PrmPageNavMenu,
        PrmSavedQueriesList,
        PrmSavedQueryFilter,
        PrmSearchResultAvailabilityLine,
        PrmSearchResultFrbrLine,
        PrmChaptersResultsLine,
        PrmSearchResultList,
        PrmSnippet,
        SearchResultSortBy,
        PrmTimesCited,
        PrmSearchResultJournalIndicationLine,
        PrmFeaturedResultItem,
        PrmSearchErrorMessage,
        PrmSearchExplain,
        PrmFeaturedResults,
        PrmSearchResultToolBar,
        PrmSearchResultAddToFavoritesMenu,
		PrmQuickLink],
    providers: [
        BriefResultService,
        CitationTrailsService,
        SnippetService,
        UpFrontActionsService,
        PageNavMenuService,
        TimesCitedService,
        SearchErrorMessageService,
        SearchResultThumbnailContainerService,
        ChaptersResultsLineService,
        SearchResultAddToFavoritesMenuService,
        FavoritesEditLabelsMenuService
        ],
    imports: [
        ActionsModule,
        'angular-inview',
        'infinite-scroll'
    ]
})
export class SearchResultModule { }


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResult.module.ts